'use client';

import {
    GRS_REFINE_QUERY_PARAM,
    LW_REFINE_QUERY_PARAM,
} from '../SearchResultsFacets/constants';

import { getSingleNonDefaultRefinementLabel } from '@/components/SearchResultsFacets/utils';
import { SEARCH_SERVICE_PROVIDERS } from '@/constants/grs';
import { PageTypes } from '@/constants/index';
import { useSearchContext } from '@/services/search/SearchProvider';
import { isCategoryLandingPageEntry } from '@/src/containers/main/utils';
import {
    CategoryLandingPage,
    GRSFacetConfigProperties,
    SearchRuleEntry,
} from '@/types/contentStack';
import { PageType } from '@/types/pages/search';
import { Text } from '@nxt-costco-com/forge-components';
import {
    type ContentStackEntryDataProps,
    useQueryParams,
} from '@nxt-costco-com/forge-digital-components';

export function CategoryPageHeading({
    pageType,
    specificPageEntry,
    grsFacetConfig,
}: {
    pageType: PageType;
    specificPageEntry?: SearchRuleEntry | CategoryLandingPage;
    grsFacetConfig:
        | ContentStackEntryDataProps<GRSFacetConfigProperties>
        | undefined;
}) {
    const { queryParams: searchParamsMap } = useQueryParams();
    const { searchService } = useSearchContext();

    const searchParams = Object.fromEntries(searchParamsMap.entries());

    if (
        pageType === PageTypes.SEARCH ||
        !isCategoryLandingPageEntry(specificPageEntry) ||
        (searchService === SEARCH_SERVICE_PROVIDERS.GRS && !grsFacetConfig)
    ) {
        return null;
    }

    // Don't render empty H1 tag is missing
    if (!specificPageEntry.category_id?.category_title) {
        return null;
    }

    // There are a bunch of special cases for showing the header text based on filters applied
    const refinementKey =
        searchService === SEARCH_SERVICE_PROVIDERS.GRS
            ? GRS_REFINE_QUERY_PARAM
            : LW_REFINE_QUERY_PARAM;
    let refine = searchParams[refinementKey];
    if (Array.isArray(refine)) {
        refine = refine[0] as string;
    }

    let existingNonDefaultRefinementLabel = '';

    if (refine) {
        existingNonDefaultRefinementLabel = getSingleNonDefaultRefinementLabel({
            refine,
            searchService,
            grsFacetConfig,
        });
    }

    if (existingNonDefaultRefinementLabel) {
        return (
            <Text variant={'t1'} component={'h1'} sx={{ marginBottom: '8px' }}>
                {existingNonDefaultRefinementLabel}{' '}
                {specificPageEntry.category_id.category_title}
            </Text>
        );
    }

    return (
        <Text variant={'t1'} component={'h1'} sx={{ marginBottom: '8px' }}>
            {specificPageEntry.category_id.category_title}
        </Text>
    );
}
